import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconPlus = props => (
  <SvgIcon {...props} viewBox="0 0 14 14">
    <path fillRule="evenodd" d="m6 0v6h-6v2h6v6h2v-6h6v-2h-6v-6h-2z" />
  </SvgIcon>
);

export default IconPlus;



// WEBPACK FOOTER //
// ./src/components/icons/IconPlus.js